import React from 'react';
import type { IconType } from 'react-icons';
import {
    FaBandcamp,
    FaEnvelope,
    FaGlobe,
    FaInstagram,
    FaSoundcloud,
    FaSpotify,
    FaYoutube,
} from 'react-icons/fa';
import { SiLinktree } from 'react-icons/si';
import { Icon } from '../components/Icon';
import { RaIcon } from '../components/RaIcon';

export interface ContactIconOption {
    id: string;
    label: string;
    render: (className?: string) => React.ReactNode;
}

const make = (icon: IconType): ContactIconOption['render'] =>
    (className) => <Icon icon={icon} className={className} />;

export const CONTACT_ICONS: ContactIconOption[] = [
    { id: 'envelope', label: 'Email', render: make(FaEnvelope) },
    { id: 'instagram', label: 'Instagram', render: make(FaInstagram) },
    { id: 'spotify', label: 'Spotify', render: make(FaSpotify) },
    { id: 'youtube', label: 'YouTube', render: make(FaYoutube) },
    { id: 'soundcloud', label: 'SoundCloud', render: make(FaSoundcloud) },
    { id: 'bandcamp', label: 'Bandcamp', render: make(FaBandcamp) },
    { id: 'linktree', label: 'Linktree', render: make(SiLinktree) },
    { id: 'ra', label: 'Resident Advisor', render: (className) => <RaIcon className={className} /> },
    { id: 'globe', label: 'Website', render: make(FaGlobe) },
];

const ICON_MAP = new Map(CONTACT_ICONS.map((i) => [i.id, i]));

export function renderContactIcon(id: string, className?: string): React.ReactNode {
    const found = ICON_MAP.get(id);
    if (!found) return null;
    return found.render(className);
}
